<template>
  <div :class="['player_wrap', videoClassName]" id="player_wrap">
    <div
      :class="['player-box', 'player-box--layout' + windowNumber]"
      :style="{ '--layoutType': Math.sqrt(windowNumber) }"
    >
      <div
        :class="[
          'player-box__item',
          'wnd_' + wnd,
          hasActive(wnd),
          hasScreen(wnd),
          hasCatch('wnd_' + wnd),
        ]"
        :ref="'wnd_' + wnd"
        v-for="wnd in maxWnd"
        :key="wnd"
        @click="handleClickWnd(wnd)"
        @dblclick="handleDblClickWnd(wnd)"
        v-show="wnd <= windowNumber"
      >
        <!-- draggable="true" -->
        <!-- <div>
          {{ wnd }}
        </div> -->
      </div>
    </div>

    <!-- 底部操作按钮 -->
    <div class="player_footer">
      <div class="left-icon">
        <el-tooltip class="item" effect="dark" content="一键关闭" placement="top-start">
          <img
            @click="handleStopAllVideo"
            class="img"
            src="@src/common/assets/images/一键关闭2.png"
            alt=""
          />
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="isSyncPlay ? '取消同步播放' : '同步播放'"
          placement="top-start"
        >
          <img
            v-show="showVideoWnd()"
            @click="handleSyncVideo"
            class="img m6"
            :src="
              !isSyncPlay
                ? require('@src/common/assets/images/同步播放2.png')
                : require('@src/common/assets/images/取消同步播放.png')
            "
            alt=""
          />
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="后退15s" placement="top-start">
          <img
            v-show="showVideoWnd()"
            @click="handleActionPlayTime(1)"
            class="img"
            src="@src/common/assets/images/后退.png"
            alt=""
          />
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="前进15s" placement="top-start">
          <img
            v-show="showVideoWnd()"
            @click="handleActionPlayTime(2)"
            class="img m6"
            src="@src/common/assets/images/前进.png"
            alt=""
          />
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="下载" placement="top-start">
          <img
            v-show="showVideoWnd()"
            @click="handleOpenDownPanel"
            class="img"
            src="@src/common/assets/images/下载.png"
            alt=""
          />
        </el-tooltip>

        <el-tooltip placement="top" v-model="playSpeed.show">
          <div slot="content">
            <span
              style="margin: 0 4px 10px; cursor: pointer"
              v-for="item in speedList"
              @click="handleCheckSpeed(item)"
              :key="item"
            >
              {{ item }}X
            </span>
          </div>
          <div class="img m6" v-show="showVideoWnd()">{{ playSpeed.value }}X</div>
        </el-tooltip>

        <span v-if="showVideoWnd()">
          {{ formatTime(videoControlInfo.playTime) }}
        </span>
      </div>
      <div v-if="showVideoWnd()">
        {{ formatTime(videoControlInfo.startTime) }}~{{
          formatTime(videoControlInfo.endTime)
        }}
      </div>
      <div class="right-icon">
        <el-tooltip class="item" effect="dark" content="一分屏" placement="top-start">
          <img
            class="img"
            @click="windowNumber = 1"
            src="@src/common/assets/images/1分屏.png"
            alt=""
          />
        </el-tooltip>
        <div style="margin: 0 8px">
          <div class="screenTip" v-if="showScreenTip">
            <div
              v-for="item in screenTypeList"
              :key="item"
              class="screenTip_item"
              @click="handleChangeScreen(+item)"
            >
              <img
                :src="require(`@src/common/assets/images/${item}分屏.png`)"
                onerror="@src/common/assets/images/1分屏.png"
                alt=""
              />
              {{ item }}分屏
            </div>
          </div>

          <span @click="showScreenTip = !showScreenTip">
            <img
              style="cursor: pointer"
              :src="require(`@src/common/assets/images/${windowNumber}分屏.png`)"
              onerror="@src/common/assets/images/1分屏.png"
              alt=""
            />
            <i
              class="changIcon"
              :class="!showScreenTip ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
            ></i>
          </span>
        </div>

        <el-tooltip class="item" effect="dark" content="全屏" placement="top-start">
          <img
            class="img"
            @click="handleScreen"
            src="@src/common/assets/images/全屏.png"
            alt=""
          />
        </el-tooltip>
      </div>
    </div>

    <!-- 录像进度条 -->
    <playerControl
      v-if="videoControlInfo.show"
      class="player_control"
      :left="videoControlInfo.left"
      :width="videoControlInfo.width"
      :start-time="videoControlInfo.startTime"
      :end-time="videoControlInfo.endTime"
      :playTime="videoControlInfo.playTime"
      :videosData="videoControlInfo.videosData"
      @handlePlayBackVideo="handlePlayBackVideo"
    />
    <!--录像分段时间选择弹窗 -->
    <el-dialog
      :title="downTime ? '录像下载' : '分段回放'"
      :visible.sync="showMultiTimeDialog"
      width="460px"
      :before-close="handleCloseMultiForm"
    >
      <el-form ref="form" :model="multiForm" label-width="80px">
        <el-form-item label="时间范围">
          <el-date-picker
            style="width: 100%"
            v-model="multiForm.time"
            type="datetimerange"
            range-separator="~"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            value-formate="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分段数" v-if="!downTime">
          <el-select
            v-model="multiForm.num"
            placeholder="请选择分段数"
            style="width: 100%"
          >
            <el-option v-for="item in [2, 3, 4]" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseMultiForm">取 消</el-button>
        <el-button type="primary" v-if="downTime" @click="handleDownVideoPanel"
          >下载</el-button
        >
        <el-button type="primary" v-else @click="handleMultiOpenVideoPanel"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dates } from "@src/common/utils";
import { api } from "../api.js";
import busVue from "@/common/utils/busVue";
import playerControl from "./player-control.vue";
export default {
  name: "player-box",
  components: {
    playerControl,
  },
  data() {
    return {
      videoClassName: "videoMonitoring",
      speedList: [-4, -2, -1, 1, 2, 4], //目前语视支持-16，-8，-4，-2，-1.。。。。16
      downTime: false,
      playSpeed: {
        show: false,
        value: 1,
      },
      videoControlInfo: {
        left: "488px",
        width: document.body.clientWidth - 488 + "px",
        show: false,
        startTime: 0, // 1687104000000,
        endTime: 0, // 1687190400000,
        playTime: 0, // 1687132800000,当前时间戳
        videosData: "",
        // JSON.stringify({
        //   0: [
        //     {
        //       cameraName: "1F财务2",
        //       cameraCode: "010010226049",
        //       StartTime: "20230619000000",
        //       EndTime: "20230620000000",
        //     },
        //   ],
        // }),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      },
      multiForm: {
        name: "",
        thirdCameraId: "",
        time: [],
        num: "4",
      },
      showMultiTimeDialog: false,
      showVideoPanel: false,
      ctx: null,
      catchRecorder: {}, //类集合
      chunksRecord: {}, //录像块集合
      videoTimeRecorder: {}, //本地录像参数时间范围
      maxWnd: 25,
      screenTypeList: [4, 6, 9, 13, 16, 25],
      showScreenTip: false,
      playPlugin: this.$store.getters.playInfo, //播放器信息
      playRecord: {}, //窗口消息集合：窗口序号：播放插件容器/id
      deviceRecord: {
        // wnd_1: {
        //   name: "1F财务2",
        //   cameraCode: "010010226049",
        //   startTime: "2023-06-19 00:00:00",
        //   endTime: "2023-06-20 00:00:00",
        //   playTime: 1687132800000,
        //   speed: 1,
        //   videoType: "back",
        // },
        // wnd_2: {
        //   name: "2F窗口",
        //   cameraCode: "010010226049",
        //   startTime: "2023-06-15 08:00:00",
        //   endTime: "2023-06-17 10:00:00",
        //   speed: 2,
        //   videoType: "back",
        // },
      }, //窗口设备信息集合：窗口序号：设备信息
      frameRecord: {}, //视频录像集合
      catchId: [], //录像窗口集合
      backTimeout: {}, //录像窗口定时器
      windowNumber: 4, //窗口数量
      activeWnd: 1, //激活的窗口序号
      screenWnd: 0, ///放大的窗口序号
      isSyncPlay: false, //同步播放
    };
  },
  created() {
    // 接收busVue摄像机选中事件回调
    busVue.$on("handleChooseCamera", (info, isBatch = false) => {
      if (!Object.keys(this.playRecord).length) {
        this.$message.warning("视频播放插件加载中，请稍后重试");
        return;
      }
      this.handleChooseCamera(info, isBatch);
    });
    // 接收录像回放时间回调
    busVue.$on("handleChooseCameraVideo", (info) => {
      this.handleChooseCameraVideo(info);
    });
    // 接收云台控制操作
    busVue.$on("handlePtzCamera", (info) => {
      this.handlePtzCamera(info);
    });
  },

  mounted() {
    let that = this;
    window.onresize = function () {
      that.videoControlInfo.width = document.body.clientWidth - 488 + "px";
    };
    // this.handleInitPlay();
    // this.dragChange();
  },
  beforeDestroy() {
    this.$app.AppInstance.handleMiniReportAlarm();
    window.onresize = null;
    busVue.$off("handleChooseCamera");
    busVue.$off("handleChooseCameraVideo");
    busVue.$off("handlePtzCamera");
    clearTimeout(this.setTimePtz);
    clearTimeout(this.setTimeLive);
    for (let key in this.backTimeout) {
      this.backTimeout[key] && clearTimeout(this.backTimeout[key]);
    }
  },
  methods: {
    dragChange() {
      let div = document.querySelectorAll(".player-box__item");
      console.log(div);
      let container = null;
      for (let i = 0; i < div.length; i++) {
        div[i].ondragstart = function () {
          console.log("开始移动");
          container = this;
        };
        div[i].ondragover = function () {
          event.preventDefault();
        };
        div[i].ondrop = function () {
          console.log("移动结束");
          if (container != null && container != this) {
            let temp = document.createElement("div");
            let domF = document.querySelector(".player-box");
            temp.appendChild(this.childNodes[0]); //当前子元素
            temp.appendChild(container.childNodes[0]); //拖动子元素
            console.log(temp);

            container.appendChild(temp.childNodes[0]); // 拖动元素变为目标元素
            this.appendChild(temp.childNodes[0]);
            // this.innerHTML=container.innerHTML
            // domF.replaceChild(temp, this);
            // domF.replaceChild(this, container);
            // domF.replaceChild(container, temp);
          }
        };
      }
    },
    // 前进/后退15s
    handleActionPlayTime(type) {
      let wndKey = "wnd_" + this.activeWnd;
      // 获取当前该播放器状态
      let that = this;
      imosSdk.playStatus(that.playRecord[wndKey].id, (result) => {
        console.log(result);
        let nextTime =
          type == 1
            ? result.status.currentTime.getTime() - 15 * 1000
            : result.status.currentTime.getTime() + 15 * 1000;
        this.handlePlayBackVideo("", nextTime);
      });
    },
    // 录像倍速控制
    handleCheckSpeed(value) {
      this.playSpeed.show = false;
      let wndKey = "wnd_" + this.activeWnd;
      if (this.deviceRecord[wndKey] && value == this.deviceRecord[wndKey].speed) {
        return;
      }
      this.deviceRecord[wndKey].speed = value;
      this.playSpeed.value = value;
      if (this.isSyncPlay) {
        //同步回放
        for (let key in this.deviceRecord) {
          if (key != wndKey && this.deviceRecord[key].videoType == "back") {
            that.handleRecordSpeed(key, value); //切换倍速
          }
        }
      } else {
        this.handleRecordSpeed(wndKey, value); //切换倍速
      }
    },
    // 录像进度条控制播放
    handlePlayBackVideo(info, startTime) {
      let checkTime = new Date(Dates.dayjs(startTime).format("YYYY-MM-DD HH:mm:ss"));
      console.log("选中时间", checkTime);
      let wndKey = "wnd_" + this.activeWnd;
      if (this.isSyncPlay) {
        //同步回放
        for (let key in this.deviceRecord) {
          if (this.deviceRecord[key].videoType == "back") {
            this.handleRecordJump(key, checkTime); //切换时间
          }
        }
      } else {
        this.handleRecordJump(wndKey, checkTime); //切换时间
      }
    },
    // 时间格式转换
    formatTime(time) {
      return time ? Dates.dayjs(time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    // 判断当前窗口是否是录像
    showVideoWnd() {
      return this.videoControlInfo.show;
    },
    // 判断插件是否初始化成功
    handleInitPlay() {
      if (this.$store.getters.isInitPlay) {
        this.handleInitWnd();
      } else {
        this.$app.AppInstance.handleInitPlay(() => {
          console.log("重新初始化成功");
          this.handleInitWnd();
        });
      }
    },
    // 初始化窗口
    handleInitWnd() {
      let className = "." + this.videoClassName + " .player-box";
      let playBox = document.querySelector(className);
      // console.log(playBox);
      for (let i = 1; i <= this.maxWnd; i++) {
        let iframeObj = imosSdk.createPanelWindow();
        if (iframeObj === null) {
          return;
        }
        this.playRecord["wnd_" + i] = iframeObj;
        playBox.childNodes[i - 1].innerHTML = "";
        playBox.childNodes[i - 1].appendChild(iframeObj);
        this.handleLiveVideoBtn("wnd_" + i); //初始化bottom-btn
      }
    },
    // 全屏显示
    handleScreen() {
      const el = document.getElementById("player_wrap");
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (isFull) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        (el.requestFullscreen && el.requestFullscreen()) ||
          (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
          (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
          (el.msRequestFullscreen && el.msRequestFullscreen());
      }
    },
    // 切换窗口
    handleChangeScreen(num) {
      this.activeWnd = 1;
      this.windowNumber = num;
      this.showScreenTip = false;
    },
    // 选中窗口
    handleClickWnd(wnd) {
      this.activeWnd = wnd;
      this.screenTip = false;
      let wndKey = "wnd_" + wnd;
      if (this.deviceRecord[wndKey] && this.deviceRecord[wndKey].videoType == "back") {
        // 如果是录像窗口
        console.log(this.deviceRecord[wndKey]);
        this.playSpeed.show = false;
        // this.playSpeed.value = this.deviceRecord[wndKey].speed;

        this.videoControlInfo.show = true;
        this.videoControlInfo.startTime = new Date(
          this.deviceRecord[wndKey].startTime
        ).getTime();
        this.videoControlInfo.endTime = new Date(
          this.deviceRecord[wndKey].endTime
        ).getTime();
        // this.videoControlInfo.playTime = new Date(
        //   this.deviceRecord[wndKey].playTime
        // ).getTime();
        this.videoControlInfo.videosData = JSON.stringify({
          0: [
            {
              cameraName: this.deviceRecord[wndKey].name,
              cameraCode: this.deviceRecord[wndKey].thirdCameraId,
              StartTime: Dates.format(
                this.deviceRecord[wndKey].startTime,
                "yyyyMMddhhmmss"
              ),
              EndTime: Dates.format(this.deviceRecord[wndKey].endTime, "yyyyMMddhhmmss"),
            },
          ],
        });
        console.log(this.videoControlInfo);
      } else {
        this.videoControlInfo.show = false;
      }
    },
    // 双击放大窗口
    handleDblClickWnd(info) {
      this.screenTip = false;
      this.screenWnd = info = this.screenWnd ? 0 : info;
    },
    // 当前激活的窗口高亮
    hasActive(wnd) {
      return this.activeWnd == wnd ? "player-box__item--active" : "";
    },
    // 当前激活的窗口放大
    hasScreen(wnd) {
      return this.screenWnd === wnd ? "full-screen" : "";
    },
    // 当前激活的窗口放大
    hasCatch(wnd) {
      return this.catchId.indexOf(wnd) != -1 ? "player-box__item--catch" : "";
    },
    // 判断当前窗口是否显示录像控制按钮
    showCatch() {
      let key = "wnd_" + this.activeWnd;
      return this.catchId.some((el) => {
        return el == key;
      });
    },
    // 双击摄像机播放视频
    handleChooseCamera(info, isBatch) {
      if (isBatch) {
        this.handleBatchPlay(info);
        return;
      }
      this.handlePlayLive(info);
    },

    // 批量播放
    handleBatchPlay(arr) {
      if (arr.length > this.maxWnd) {
        this.$message.warning("当前最多支持播放" + this.maxWnd + "路视频");
      }
      let playArr = [...arr].splice(0, this.maxWnd + 1);
      playArr.forEach((item) => {
        setTimeout(() => {
          this.handlePlayLive(item);
        });
      });
    },
    // 查询摄像机录像
    handleChooseCameraVideo(info) {
      this.handlePlayVideo(info);
    },

    // 视频直播
    async handlePlayLive(deviceInfo, checkIndex) {
      console.log("实况设备信息", deviceInfo);
      this.setTimeLive && clearTimeout(this.setTimeLive);
      let that = this;
      let index = checkIndex || (await this.handleGetFreeWnd());
      let wndKey = "wnd_" + index;
      console.log("窗口位置", index);
      if (!that.playRecord || !that.playRecord[wndKey] || !that.playRecord[wndKey].id) {
        that.$message.warning("插件正在加载中,请稍后");
        return;
      }
      this.activeWnd = index;
      // 存储设备-窗口关系
      that.deviceRecord[wndKey] = { ...deviceInfo, videoType: "live" };

      imosSdk.playLive(
        that.playRecord[wndKey].id,
        deviceInfo.thirdCameraId,
        deviceInfo.name,
        (res) => {
          console.log(res);
          if (res.ErrCode == 55001) {
            // 该业务已切换
            // that.handleStopVideo(wndKey);
            // this.setTimeLive = setTimeout(() => {
            //   this.handlePlayLive(deviceInfo, index);
            // }, 1000);
            // return;
          }
          if (res.ErrCode == -1) {
            // 未找到窗格或创建窗格video失败
            // that.handlePlayLive(deviceInfo, index);
            // this.handleInitWnd();
            return;
          }
          // if (res.ErrCode != 0 && res.ErrCode != -1 && res.ErrCode != 55001) {
          //   this.$message.error(res.ErrMsg || "视频获取失败，请稍后再试");
          // }

          that.handleAddWndTitle(wndKey, deviceInfo); //添加标题
          that.delBottomBtn({
            wndKey: wndKey,
            buttonId: "videoMulti",
          });
          // that.handleLiveVideoBtn(wndKey, deviceInfo); //添加关闭btn,本地录像btn，即时回放btn，上报告警btn
          that.handleClickWnd(this.activeWnd);
          busVue.$emit("handlePlayLiveCallBack", {
            state: 1, //1表示播放，2表示关闭
            ...deviceInfo,
            videoType: "live",
          });
        },
        1
      );
    },
    // 视频录像
    async handlePlayVideo(deviceInfo) {
      this.screenWnd = 0;
      console.log("录像设备信息", deviceInfo);
      let that = this;
      let index = await this.handleGetFreeWnd();
      this.activeWnd = index;
      let wndKey = "wnd_" + index;
      let setBackInfo = {
        videoType: "back",
        speed: 1,
      };
      that.deviceRecord[wndKey] = { ...deviceInfo, ...setBackInfo }; //存储设备信息
      // 播放录像
      imosSdk.playRecord(
        that.playRecord[wndKey].id, //窗口id
        deviceInfo.thirdCameraId, //摄像机编码
        deviceInfo.name, //标题名称
        deviceInfo.startTime, //new Date("2022-11-25 10:00:00"),
        deviceInfo.endTime, //new Date("2022-11-27 10:00:00"),
        (res) => {
          console.log(res);
          if (res.ErrCode != 0 && res.ErrCode != -1) {
            this.$message.error(res.ErrMsg || "视频获取失败，请稍后再试");
          }
          that.handleAddWndTitle(wndKey, deviceInfo);
          // that.handleBackVideoBtn(wndKey, deviceInfo); //添加关闭btn,分段回放btn，上报告警btn
          that.handleAddSetTimeOut(wndKey);
          that.delBottomBtn({
            wndKey: wndKey,
            buttonId: "videoBack",
          });
          that.handleClickWnd(this.activeWnd);
          busVue.$emit("handlePlayLiveCallBack", {
            state: 1, //1表示播放，2表示关闭
            ...deviceInfo,
            videoType: "back",
          });
        }
      );
    },
    // 隐藏btn
    hiddenVideoBtn(option) {
      let that = this;
      imosSdk.hiddenVideoBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.videoItem,
        function (res) {
          // console.log("隐藏按钮", res);
        }
      );
    },
    //添加titleBtn
    addVideoBtn(option) {
      let that = this;
      imosSdk.addTitleBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.buttonInfo,
        (res) => {
          option.clickFunc(option.wndKey);
        }
      );
    },
    // 添加控制栏按钮
    addBottomBtn(option) {
      let that = this;
      imosSdk.addBottomBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.buttonInfo,
        (res) => {
          option.clickFunc(option.wndKey);
        }
      );
    },
    // 删除控制栏按钮
    delBottomBtn(option) {
      // console.log("准备删除");
      let that = this;
      imosSdk.delBottomBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.buttonId,
        (res) => {
          // console.log("删除按钮", res);
        }
      );
    },
    // 为录像添加定时器
    handleAddSetTimeOut(wndKey) {
      if (this.backTimeout[wndKey]) {
        clearTimeout(this.backTimeout[wndKey]);
        delete this.backTimeout[wndKey];
        this.handleAddSetTimeOut(wndKey);
      } else {
        this.backTimeout[wndKey] = setTimeout(() => {
          imosSdk.playStatus(this.playRecord[wndKey].id, (result) => {
            // console.log(result);
            let nowWndKey = "wnd_" + this.activeWnd;
            if (nowWndKey == wndKey) {
              let currentTime = result?.status?.currentTime.getTime();
              let speed = result.status.speed;
              this.videoControlInfo.playTime = currentTime;
              this.playSpeed.value = speed;
            }
          });
          this.handleAddSetTimeOut(wndKey);
        }, 1000);
      }
    },
    // 录像窗口自定义按钮--暂时不用
    handleBackVideoBtn(wndKey, deviceInfo) {
      let that = this;
      that.hiddenVideoBtn({
        wndKey: wndKey,
        videoItem: {
          type: 4,
          btnId: ["close"],
        },
      });
      that.addVideoBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoClose",
          className: "videoClose videoBtn",
          iconUrl: "/images/theme/newDark/play-box/关闭.png", //路径基于public
          tip: "关闭",
        },
        clickFunc: that.handleStopVideo,
      });
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoMulti",
          className: "videoMulti videoBtn",
          tip: "分段回放",
        },
        clickFunc: this.handleMultiVideo,
      });
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoAlarm",
          className: "videoBack videoBtn",
          tip: "上报告警",
        },
        clickFunc: that.handleAddAlarm,
      });
    },
    handleMultiVideo(wndKey) {
      this.multiForm = {
        num: 4,
        time: [
          new Date(this.deviceRecord[wndKey].startTime),
          new Date(this.deviceRecord[wndKey].endTime),
        ],
        thirdCameraId: this.deviceRecord[wndKey].thirdCameraId,
        name: this.deviceRecord[wndKey].name,
      };
      this.showMultiTimeDialog = true;
    },
    // 默认窗口自定义按钮
    handleLiveVideoBtn(wndKey, deviceInfo) {
      let that = this;
      that.hiddenVideoBtn({
        wndKey: wndKey,
        videoItem: {
          type: 4,
          btnId: ["close"],
        },
      });
      // 本地录像btn
      that.addVideoBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoRecord",
          className: "videoRecord videoBtn",
          iconUrl: "/images/theme/newDark/play-box/视频回放.png", //路径基于public
          tip: "本地录像",
        },
        clickFunc: that.handleRecordCall,
      });
      // 关闭btn
      that.addVideoBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoClose",
          className: "videoClose videoBtn",
          iconUrl: "/images/theme/newDark/play-box/关闭.png", //路径基于public
          tip: "关闭",
        },
        clickFunc: that.handleStopVideo,
      });
      //上报告警btn
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoAlarm",
          className: "videoAlarm videoBtn",
          tip: "上报告警",
        },
        clickFunc: that.handleAddAlarm,
      });
      //录像回放btn
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoBack",
          className: "videoBack videoBtn",
          tip: "即时回放",
        },
        clickFunc: that.handleOpenVideoDialog,
      });

      // 分段回放
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoMulti",
          className: "videoMulti videoBtn",
          tip: "分段回放",
        },
        clickFunc: that.handleMultiVideo,
      });
    },

    // 上报告警
    handleAddAlarm(wndKey) {
      this.$app.AppInstance.handleMiniReportAlarm(
        {
          name: this.deviceRecord[wndKey].name, //摄像机名称
          thirdCameraId: this.deviceRecord[wndKey].thirdCameraId, //摄像机id
          playRecordId: this.playRecord[wndKey].id, //窗口id
        },
        {
          right: "16px",
        }
      );
    },
    // 即时回放，默认回放前5h
    handleOpenVideoDialog(wndKey) {
      this.$app.AppInstance.handleMiniPlayDialog({
        playType: "back",
        playTitle: this.deviceRecord[wndKey].name, //摄像机名称
        playId: this.deviceRecord[wndKey].thirdCameraId, //摄像机id
        startTime: new Date().getTime() - 1000 * 60 * 60 * 5, //如果没有时间默认最新一分钟
        endTime: new Date().getTime(),
      });
    },
    handleCloseMultiForm() {
      this.showMultiTimeDialog = false;
      this.$refs.form.resetFields();
    },
    // 开启录像分段播放
    handleMultiOpenVideoPanel() {
      this.showMultiTimeDialog = false;
      this.$emit("handleMultiOpenVideoPanel", this.multiForm);
    },
    handleOpenDownPanel() {
      this.downTime = true;
      let wndKey = "wnd_" + this.activeWnd;
      this.multiForm = {
        time: [
          new Date(this.deviceRecord[wndKey].startTime),
          new Date(this.deviceRecord[wndKey].endTime),
        ],
        thirdCameraId: this.deviceRecord[wndKey].thirdCameraId,
        name: this.deviceRecord[wndKey].name,
      };
      this.showMultiTimeDialog = true;
    },
    // 录像下载
    handleDownVideoPanel() {
      let wndKey = "wnd_" + this.activeWnd;
      let startTime = this.multiForm.time[0];
      let endTime = this.multiForm.time[1];
      this.handleDownVideo(wndKey, startTime, endTime);
      this.handleCloseMultiForm();
    },
    handleRecordCall(wndKey) {
      if (this.catchId.indexOf(wndKey) != -1) {
        // 取消直接下载
        this.stopVideoRecord(wndKey);
        // this.$message.warning("取消录像");
        // this.cancelVideoRecord(wndKey);
        // console.log("取消本地录像");
        return;
      }
      console.log("开始本地录像");
      this.startVideoRecord(wndKey);
      this.catchId.push(wndKey);
    },
    // 录像下载
    handleDownVideo(wndKey, startTime, endTime) {
      imosSdk.downloadRecord(
        this.deviceRecord[wndKey].thirdCameraId,
        startTime,
        endTime,
        (result) => {
          console.log("录像下载", result);
        }
      );
    },
    // 录像跳转到某个时间点
    handleRecordJump(wndKey, startTime) {
      console.log(wndKey, startTime);
      imosSdk.recordJump(this.playRecord[wndKey].id, startTime, (result) => {
        console.log("录像跳转成功", result);
        console.log(this.videoControlInfo);
        this.videoControlInfo.playTime = startTime.getTime();
      });
    },
    // 录像倍速切换
    handleRecordSpeed(wndKey, speed) {
      imosSdk.recordSpeed(this.playRecord[wndKey].id, speed, (result) => {
        console.log("倍速切换成功", result);
      });
    },
    // 录像暂停/播放状态
    handleSwitchPlayStatus(wndKey, canPlay) {
      imosSdk.switchPlayStatus(
        this.deviceRecord[wndKey].thirdCameraId,
        (result) => {
          console.log("播放状态切换成功", result);
        },
        canPlay
      );
    },

    // 抓拍
    handleDownCatch(wndKey) {
      imosSdk.playCatch(that.playRecord[wndKey].id, (result) => {
        console.log("抓拍图片", result);
      });
    },
    // 云台控制
    handlePtzCamera(info) {
      let wndKey = "wnd_" + this.activeWnd;
      let cameraCode =
        this.deviceRecord[wndKey] && this.deviceRecord[wndKey].thirdCameraId;
      console.log(cameraCode);
      if (!cameraCode) {
        this.$message.warning("该窗口未配置视频,请选择正确的视频窗口");
        return;
      }

      let params = {
        PTZCmdID: info.optCode,
        PTZCmdPara1: info.speed,
        PTZCmdPara2: info.speed,
        PTZCmdPara3: info.speed,
      };
      let controlRes = false;
      // 鼠標按下
      if (info != "" && info.modeCode === 1) {
        this.$fetch(api.ptcStart + "/" + cameraCode, params).then((res) => {
          if (res.ErrCode === 0) {
            this.$fetch(api.ptcControl + "/" + cameraCode, params).then((res) => {
              if (res.ErrCode === 0) {
                console.info("鼠标按下成功===");
                controlRes = true;
              }
            });
          } else {
            this.$message.error("播放器错误:" + res.ErrMsg);
          }
        });
      }
      // 鼠標抬起
      if (info != "" && info.modeCode === 2 && controlRes) {
        this.$fetch(api.ptcStart + "/" + cameraCode, params).then((res) => {
          if (res.ErrCode === 0) {
            let stopParams = { ...params, PTZCmdID: 0x0901 };
            this.$fetch(api.ptcControl + "/" + cameraCode, stopParams).then((res) => {
              if (res.ErrCode === 0) {
                console.info("鼠标抬起成功===");
                // this.$message.success("操作状态:" + res.ErrMsg);
                info.callBack();
              }
            });
          } else {
            this.$message.error("播放器错误:" + res.ErrMsg);
          }
        });
      }
    },
    // 同步播放
    handleSyncVideo() {
      if (!this.isSyncPlay) {
        let backVideo = [];
        for (let key in this.deviceRecord) {
          if (this.deviceRecord[key].videoType == "back") {
            // 过滤出录像设备
            backVideo.push(this.deviceRecord[key]);
          }
        }
        if (backVideo.length < 2) {
          this.$message.warning("同步播放至少需要2路录像，请添加录像");
          return;
        } else {
          // 开启同步播放
          this.isSyncPlay = true;
        }
      } else {
        // 关闭同步播放
        this.isSyncPlay = false;
      }
    },
    // 关闭所有视频
    handleStopAllVideo() {
      for (let key in this.playRecord) {
        this.deviceRecord[key] && this.handleStopVideo(key);
      }
      this.$nextTick(() => {
        this.activeWnd = 1;
        this.isSyncPlay = false;
        this.videoControlInfo.show = false;
      });
    },
    // 关闭单个视频
    handleStopVideo(wndKey) {
      if (this.catchId.indexOf(wndKey) != -1) {
        // 取消直接下载
        this.stopVideoRecord(wndKey);
      }
      let that = this;
      let index = wndKey.split("_")[1];
      let iframeId = this.playRecord[wndKey].id;
      //清除摄像机名称

      let className = "." + this.videoClassName + " ." + wndKey;
      let activeDom = document.querySelector(className);
      if (index <= this.windowNumber) {
        activeDom.setAttribute("style", "--deviceName:" + "");
      } else {
        activeDom.setAttribute("style", "display:" + "none");
      }
      // 关闭摄像机直播
      imosSdk.playStop(iframeId, function (e) {
        busVue.$emit("handlePlayLiveCallBack", {
          state: 2, //1表示播放，2表示关闭
          ...that.deviceRecord[wndKey],
        });
        if (that.deviceRecord[wndKey] && that.deviceRecord[wndKey].videoType == "back") {
          that.addBottomBtn({
            wndKey: wndKey,
            buttonInfo: {
              id: "videoBack",
              className: "videoBack videoBtn",
              tip: "即时回放",
            },
            clickFunc: that.handleOpenVideoDialog,
          });
          that.playSpeed.show = false;
          that.videoControlInfo.show = false;
          delete that.deviceRecord[wndKey];
        }
        if (that.deviceRecord[wndKey] && that.deviceRecord[wndKey].videoType == "live") {
          that.addBottomBtn({
            wndKey: wndKey,
            buttonInfo: {
              id: "videoMulti",
              className: "videoMulti videoBtn",
              tip: "分段回放",
            },
            clickFunc: that.handleMultiVideo,
          });
          delete that.deviceRecord[wndKey];
        }
        // that.handleClickWnd(index);
        if (that.backTimeout[wndKey]) {
          clearTimeout(that.backTimeout[wndKey]);
          delete that.backTimeout[wndKey];
        }
      });
    },
    // 获取空余窗口
    handleGetFreeWnd(wnd = this.activeWnd) {
      return new Promise((resolve) => {
        // wnd默认为1，依次递增
        if (this.screenWnd > 0) {
          // 如果窗口放大状态,替换当前放大的窗口
          this.deviceRecord[`wnd_${this.screenWnd}`] &&
            this.handleStopVideo("wnd_" + this.screenWnd);
          setTimeout(() => {
            resolve(this.screenWnd);
          }, 200);
          return;
        }

        const _activeKey = `wnd_${wnd}`;
        // 当前选中窗口是否有视频播放
        if (!this.deviceRecord[_activeKey]) {
          resolve(wnd);
          return;
        } else {
          // 先满足空余窗口的播放,在满足指定窗口的播放
          for (let i = 1; i <= this.maxWnd; i++) {
            let className = "." + this.videoClassName + " .wnd_" + i;
            let maskEle = document
              .querySelector(className)
              .querySelector(".imosVideo-mask");

            if (!this.deviceRecord[`wnd_${i}`] && maskEle) {
              this.setWndNumber(i);
              resolve(i);
              return;
            } else {
              // 最后一轮:如果没有空余窗口,则替换当前选中的窗口
              if (i == this.maxWnd) {
                this.handleStopVideo("wnd_1");
                setTimeout(() => {
                  resolve(1);
                }, 200);
              }
            }
          }
        }
      });
    },
    // 计算适合当前播放器的窗口数量
    setWndNumber(i) {
      // 默认9窗口,如果窗口位置超出当前显示的窗口,则依次显示13,16,25窗口
      if (i <= this.windowNumber) {
        return;
      }
      if (i > 1 && i <= 4) {
        this.windowNumber = 4;
      }
      if (i > 4 && i <= 6) {
        this.windowNumber = 6;
      }
      if (i > 6 && i <= 9) {
        this.windowNumber = 9;
      }
      if (i > 9 && i <= 13) {
        this.windowNumber = 13;
      }
      if (i > 13 && i <= 16) {
        this.windowNumber = 16;
      }
      if (i > 16 && i <= 25) {
        this.windowNumber = 25;
      }
    },
    // 添加窗口标题
    handleAddWndTitle(wndKey, deviceInfo) {
      // 通过添加伪元素显示标题
      let className = "." + this.videoClassName + " ." + wndKey;
      let activeDom = document.querySelector(className);
      activeDom.setAttribute("style", "--deviceName:" + "'" + deviceInfo.name + "'");
    },

    // 开始录像-本地录像
    startVideoRecord(wndKey) {
      const canvas = document.createElement("canvas");
      canvas.width = 360;
      canvas.height = 270;
      const frameRate = 60;
      const encodeType = "video/webm";
      this.chunksRecord[wndKey] = [];
      this.ctx = canvas.getContext("2d");
      this.ctx.fillStyle = "deepskyblue";
      this.ctx.fillRect(0, 0, 360, 270);
      // 创建MediaRecorder，设置媒体参数
      const stream = canvas.captureStream(frameRate);
      this.catchRecorder[wndKey] = new MediaRecorder(stream, {
        mimeType: encodeType,
      });
      this.showRecord = true;
      // 收集录制数据
      this.catchRecorder[wndKey].ondataavailable = (e) => {
        if (e.data && e.data.size && this.chunksRecord[wndKey]) {
          this.chunksRecord[wndKey].push(e.data);
        }
      };
      // 开始录像
      this.catchRecorder[wndKey].start(10);
      this.drawFrame(wndKey);
    },
    drawFrame(wndKey) {
      let className = "." + this.videoClassName + " ." + wndKey;
      let video = document.querySelector(className).querySelector(".imosVideo-fitIcon");
      this.ctx.drawImage(video, 0, 0, 360, 270);
      this.frameRecord[wndKey] = requestAnimationFrame(() => {
        this.drawFrame(wndKey);
      });
    },
    // 取消录像
    cancelVideoRecord(wndKey) {
      this.showRecord = false;
      this.catchRecorder[wndKey].stop();
      this.chunksRecord[wndKey] && delete this.chunksRecord[wndKey];
      this.catchId.splice(this.catchId.indexOf(wndKey), 1);
    },
    // 关闭录像
    stopVideoRecord(wndKey) {
      this.showRecord = false;
      this.catchRecorder[wndKey].stop();
      cancelAnimationFrame(this.frameRecord[wndKey]);
      this.catchId.splice(this.catchId.indexOf(wndKey), 1);
      this.download(wndKey);
    },
    // 视频下载
    download(key) {
      const blob = new Blob(this.chunksRecord[key]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = this.deviceRecord[key].name + new Date().getTime() + ".mp4";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.$nextTick(() => {
        this.chunksRecord[key] && delete this.chunksRecord[key];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .imosSdk-video {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}

:deep .videoAlarm {
  background: url("/images/theme/newDark/play-box/上报告警.png") center no-repeat !important;
}
:deep .videoBack {
  background: url("/images/theme/newDark/play-box/即时回放.png") center no-repeat !important;
}
:deep .videoMulti {
  background: url("/images/theme/newDark/play-box/分段回放.png") center no-repeat !important;
}
:deep .imosVideo-replay-common-function {
  width: 126px !important;
}
:deep .imosVideo-title-icon {
  display: flex;
  top: 0;
  flex-direction: row-reverse;
}
:deep .imosVideo-mask {
  background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat !important;
  background-size: 100%;
}

:deep .imosVideo-playPauseIcon {
  display: none !important;
}
.player_wrap {
  flex: 1;
  height: 100%;
  position: relative;
  margin-left: 6px;
}
.player_footer {
  // margin: 0 12px;
  height: 40px;
  padding: 0 12px;
  background: #0b1223;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-icon,
  .right-icon {
    display: flex;
    align-items: center;
    position: relative;
  }
  .screenTip {
    position: absolute;
    top: -110px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 200px;
    right: -12px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid royalblue;
    z-index: 3;
    @include set_theme_color(background-color, left-menu-bg-color);
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 67%;
      border-width: 8px;
      border-style: solid;
      border-color: royalblue transparent transparent transparent;
    }
    &_item {
      width: 43%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      &:hover {
        color: royalblue;
      }
    }
  }
  .changIcon {
    font-size: 20px;
    position: relative;
    top: -4px;
    margin-left: 3px;
    cursor: pointer;
  }
  .img {
    cursor: pointer;
  }
  .m6 {
    margin: 0 6px;
  }
}

.player_control {
  margin-top: 0px;
  background: #181f2e;
  padding: 5px 0;
}
.player-box {
  width: 100%;
  height: calc(100% - 106px);
  padding: 12px;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  @include set_theme_color(background-color, left-menu-bg-color);
  .full-screen {
    width: calc(100% - 24px) !important;
    height: calc(100% - 24px) !important;
    position: absolute;
    left: 12px !important;
    top: 12px !important;
    z-index: 3;
  }

  &--layout6 {
    .player-box__item {
      width: calc(100% / 3 - 1px);
      height: calc(100% / 3 - 2px);
    }
    .player-box__item:first-child {
      width: calc(100% / 3 * 2 - 0.5px);
      height: calc(100% / 3 * 2 - 3px);
    }

    .player-box__item:nth-child(3) {
      position: absolute;
      top: calc(100% / 3 + 3px);
      right: 12px;
      height: calc(100% / 3 - 10px);
      width: calc(100% / 3 - 9px);
    }
  }

  &--layout13 {
    .player-box__item {
      width: calc(100% / 4 - 1px);
      height: calc(100% / 4 - 2px);
    }

    .player-box__item:nth-child(6) {
      height: calc(100% / 4 - 8px);
      width: calc(100% / 4 - 7px);
      position: absolute;
      top: 50%;
    }

    .player-box__item:nth-child(7) {
      height: calc(100% / 2 - 1px);
      width: calc(100% / 2 - 2px);
    }

    .player-box__item:nth-child(9) {
      position: absolute;
      top: 50%;
      right: 12px;
      height: calc(100% / 4 - 8px);
      width: calc(100% / 4 - 7px);
    }
  }

  &__item {
    width: calc(100% / var(--layoutType) - 1px);
    height: calc(100% / var(--layoutType) - 2px);
    background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat;
    // background-size: 100% 100%;
    border: 1px solid #181f2e;
    transition: all 0s ease-in;
    position: relative;

    &--active {
      border-color: royalblue;
    }
    &--catch {
      &::before {
        content: "REC";
        position: absolute;
        z-index: 2;
        width: 36px;
        height: 18px;
        line-height: 18px;
        border-radius: 50%;
        top: 31px;
        font-size: 12px;
        text-align: center;
        right: 20px;
        display: block;
        background: red;
        animation: rec 0.5s infinite alternate;
      }
    }
    &:hover {
      &::after {
        display: none;
      }
    }
    &::after {
      content: var(--deviceName);
      position: absolute;
      z-index: 2;
      top: 10px;
      right: 2px;
      padding: 1px 11px;
      border-radius: 3px;
      font-size: 18px;
      display: block;
    }
  }
  @keyframes rec {
    0% {
      opacity: 0.8;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
